/* eslint-disable */
import axios from "../../axios";
import { GET_USER_INFO, LOGIN, FORGOT_PASSWORD, CHECK_OTP, RESET_PASSWORD, GET_CONFIG, REGISTER_TOKEN, GET_DOMAIN, UPDATE_BUSINESS_INFO , GET_USER_SIGNIN_INFO} from "./moduleAuthTypes"
import { URL_LOGIN, URL_GET_USER_INFO, URL_FORGOT_PASSWORD, URL_CHECK_OTP, URL_RESET_PASSWORD, URL_GET_CONFIG, URL_REGISTER_TOKEN, URL_GET_DOMAIN, URL_REMOVE_TOKEN ,URL_GET_USER_SIGNIN_INFO } from "./moduleAuthUrls"
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
import axiosDNS from "axios";
import baseAxios from "axios";

export default {
  login({ commit, getters, dispatch }, item) {
    localStorage.removeItem('accessToken');
    return new Promise((resolve, reject) => {
      commit('auth_request')
      var bodyFormData = new FormData();
      for (var key in item) {
        bodyFormData.append(key, item[key])
      }
      let domain = getters.idDomain.domain
      if (process.env.NODE_ENV != "development") {
        domain = domain.replace('http://', 'https://')
      }
      baseAxios.post(`${URL_LOGIN}`, bodyFormData, {
        headers: {
          'G-ClientID': getters.idDomain.client_id,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        baseURL: domain
      })
        .then(resp => {
          const token = resp.data.result.data.access_token
          localStorage.setItem('accessToken', token)
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
          commit('auth_success', token, bodyFormData)
          commit('login', resp.data.result.data)
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          localStorage.removeItem('accessToken')
          reject(err)
        })
    })
  },

  loginByToken({ commit, getters }, token) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      let domain = getters.idDomain.domain
      if (process.env.NODE_ENV != "development") {
        domain = domain.replace('http://', 'https://')
      }
      baseAxios.get(URL_GET_USER_INFO, {
        headers: {
          'G-ClientID': getters.idDomain.client_id,
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': 'Bearer ' + token
        },
        baseURL: domain
      })
        .then(resp => {
          // const token = resp.data.result.data.access_token
          // localStorage.setItem('accessToken', token)
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
          // commit('auth_success', token, {})
          // commit('login', resp.data.result.data)
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          localStorage.removeItem('accessToken')
          reject(err)
        })
    })
  },

  logout({ commit, getters }) {
    return new Promise((resolve) => {
      if (localStorage.getItem('fcmToken') != null) {
        let bodyFormData = new FormData();
        bodyFormData.append('token', localStorage.getItem('fcmToken'));
        let domain = localStorage.getItem('endpoint');
        let id = localStorage.getItem('domainId')
        baseAxios.post(URL_REMOVE_TOKEN, bodyFormData, {
          headers: {
            'G-ClientID': id,
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          baseURL: domain
        })
      }
      commit('logout');
      // localStorage.removeItem('accessToken')
      // localStorage.removeItem('domainId')
      // localStorage.removeItem('endpoint')
      localStorage.clear();
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  },

  [GET_USER_INFO]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      if (process.env.NODE_ENV != "development") {
        let domain = localStorage.getItem('domainId');
        let version = localStorage.getItem('appVersion');
        axiosDNS.get(URL_GET_DOMAIN, { params: { id: domain, type: 'new' }, baseURL: "https://dns.fast-boy.net" })
          .then((response) => {
            let responseModel = new ResponseModel(response);
            if (responseModel.status == STATUS_OK) {
              let resultModel = responseModel.result;
              if (resultModel.status == "OK") {
                let data = resultModel.data;
                data.domain = data.domain.replace('http://', 'https://')
                localStorage.setItem('appMercure', data.app_mercure.data);
                commit('MERCURE_DATA', JSON.parse(data.app_mercure.data));
                if (version != data.app_version.version) {
                  commit('logout');
                  localStorage.removeItem('accessToken');
                  delete axios.defaults.headers.common['Authorization'];
                  reject("Version mismatch");
                }
              } else {
                reject(resultModel.message);
              }
            } else {
              reject(responseModel.message);
            }
          })
      }
      axios.get(`${URL_GET_USER_INFO}`)
        .then((response) => {
          if (response.data.result == null) {
            commit(GET_USER_INFO, {});
            resolve({})
          } else {
            commit(GET_USER_INFO, response.data.result.data);
            dispatch(GET_CONFIG);
            resolve(response.data.result.data)
          }
        })
        .catch((error) => {
          if (localStorage.getItem('accessToken') == null || error.response.status == 401) {
            commit('logout');
            localStorage.removeItem('accessToken');
            delete axios.defaults.headers.common['Authorization'];
            reject(error);
          }

          if(error.response.status == 403) {
            reject(error.response.data);
          }
        })
    })
  },

  [UPDATE_BUSINESS_INFO]({ }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        if (item[key] != null) {
          data.append(key, item[key]);
        }
      }
      axios.post(URL_GET_USER_INFO, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_CONFIG]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(URL_GET_CONFIG)
        .then((response) => {
          if (response.data.result == null) {
            commit(GET_CONFIG, {});
            resolve({})
          } else {
            let code = localStorage.getItem('country_code');
            if (code == null || code != response.data.result.data.settings.country_code) {
              localStorage.setItem('country_code', response.data.result.data.settings.country_code);
            }
            if (response.data.result.data.settings.passcode_active) {
              localStorage.setItem('passcode_active', response.data.result.data.settings.passcode_active);
            } else {
              localStorage.setItem('passcode_active', 0);
            }
            if (response.data.result.data.settings.web_admin_passcode_active) {
              localStorage.setItem('web_admin_passcode_active', response.data.result.data.settings.web_admin_passcode_active);
            } else {
              localStorage.setItem('web_admin_passcode_active', 0);
            }
            commit(GET_CONFIG, response.data.result.data.settings);
            resolve(response.data.result.data.settings)
          }
        })
        .catch((error) => { reject(error); })
    })
  },

  // eslint-disable-next-line
  [LOGIN]({ }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_LOGIN}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  // eslint-disable-next-line
  [REGISTER_TOKEN]({ }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_REGISTER_TOKEN}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  // eslint-disable-next-line
  [FORGOT_PASSWORD]({ }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_FORGOT_PASSWORD}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  // eslint-disable-next-line
  [CHECK_OTP]({ commit }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_CHECK_OTP}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(CHECK_OTP, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  // eslint-disable-next-line
  [RESET_PASSWORD]({ }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_RESET_PASSWORD}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_USER_SIGNIN_INFO]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_USER_SIGNIN_INFO}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_USER_SIGNIN_INFO, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  // eslint-disable-next-line
  [GET_DOMAIN]({ commit }, domain) {
    return new Promise((resolve, reject) => {
      if (process.env.NODE_ENV != "development") {
        axiosDNS.get(URL_GET_DOMAIN, { params: { id: domain, type: 'new' }, baseURL: "https://dns.fast-boy.net" })
          .then((response) => {
            console.log(response)
            let responseModel = new ResponseModel(response);
            if (responseModel.status == STATUS_OK) {
              let resultModel = responseModel.result;
              if (resultModel.status == "OK") {
                let data = resultModel.data;
                if (process.env.NODE_ENV != "development") {
                  data.domain = data.domain.replace('http://', 'https://')
                }
                localStorage.setItem('endpoint', data.domain);
                localStorage.setItem('domainId', domain);
                localStorage.setItem('appVersion', data.app_version.version);
                localStorage.setItem('appMercure', data.app_mercure.data);
                commit('ID_DOMAIN', data);
                commit('MERCURE_DATA', JSON.parse(data.app_mercure.data));
                resolve(data);
              } else {
                reject(resultModel.message);
              }
            } else {
              reject(responseModel.message);
            }
          })
          .catch((error) => { reject(error) });
      } else {
        // axiosDNS.get(URL_GET_DOMAIN, { params: { id: domain }, baseURL: "http://dns.gci.net" })
        //   .then((response) => {
        //     let responseModel = new ResponseModel(response);
        //     if (responseModel.status == STATUS_OK) {
        //       let resultModel = responseModel.result;
        //       if (resultModel.status == 200) {
        //         let data = resultModel.data;
        //         if (process.env.NODE_ENV != "development") {
        //           data.domain = data.domain.replace('http://', 'https://')
        //         }
        //         localStorage.setItem('endpoint', data.domain);
        //         localStorage.setItem('domainId', domain);
        //         commit('ID_DOMAIN', data);
        //         resolve(data);
        //       } else {
        //         reject(resultModel.message);
        //       }
        //     } else {
        //       reject(responseModel.message);
        //     }
        //   })
        //   .catch((error) => { reject(error) });
        localStorage.setItem('endpoint', process.env.VUE_APP_DEVELOPMENT_DOMAIN_ENDPOINT);
        localStorage.setItem('domainId', process.env.VUE_APP_DEVELOPMENT_DOMAIN_ID);
        let data = { client_id: process.env.VUE_APP_DEVELOPMENT_DOMAIN_ID, domain: process.env.VUE_APP_DEVELOPMENT_DOMAIN_ENDPOINT };
        commit('ID_DOMAIN', data);
        resolve(data);
      }
    })
  }

}
